import axios from 'axios';
import EventBus from 'eventing-bus';
import { all, takeEvery, call, put } from 'redux-saga/effects';

// Fetch all payment plans from the server
function* getPlans() {
  const { error, response } = yield call(getCall, '/payment/plansAuth');
  if (error) return EventBus.publish('error', error['response']['data']['message']);
  else if (response) yield put({ type: 'SET_PLANS', payload: response['data']['body'] });
}

// Create a new subscription for the workspace
function* getCurrentPlan() {
  const { error, response } = yield call(getCall, '/payment/getCurrentPlan');
  if (error) return EventBus.publish('error', error['response']['data']['message']);
  else if (response) yield put({ type: 'SET_CURRENT_PLAN', payload: response['data']['body'] });
}

// Get Credit Packages
function* getCreditPackages() {
  const { error, response } = yield call(getCall, '/payment/getCreditPackages');
  if (error) return EventBus.publish('error', error['response']['data']['message']);
  else if (response) yield put({ type: 'SET_CREDIT_PACKAGES', payload: response['data']['body'] });
}

// Create a new subscription for the workspace
function* createPortalSession() {
  const { error, response } = yield call(getCall, '/payment/createPortalSession');
  if (error) return EventBus.publish('error', error['response']['data']['message']);
  else if (response) window.location.href = response['data']['body']['url'];
}

// Create a new subscription for the workspace
function* createCheckoutSession({ payload }) {
  const { data, successCallback } = payload;
  const { error, response } = yield call(postCall, { path: '/payment/createCheckoutSession', payload: data });
  if (error) return EventBus.publish('error', error['response']['data']['message']);
  else if (response) {
    const responseBody = response['data']['body'];

    // For downgrades, no checkout URL - just show confirmation
    if (responseBody['changeType'] === 'downgrade') {
      if (successCallback) successCallback(responseBody);
      return;
    }

    // For upgrades and new subscriptions, redirect to checkout
    if (successCallback) successCallback(responseBody);
    if (responseBody['url']) {
      window.location.href = responseBody['url'];
    }
  }
}

// Fetch all payment plans from the server
function* getPayments() {
  const { error, response } = yield call(getCall, '/payment/history');
  if (error) return EventBus.publish('error', error['response']['data']['message']);
  else if (response) yield put({ type: 'SET_PAYMENTS', payload: response['data']['body'] });
}

// Get Usage Metrics
function* getUsageMetrics({ payload }) {
  const { error, response } = yield call(postCall, { path: '/payment/usageDetails', payload });
  if (error) return EventBus.publish('error', error['response']['data']['message']);
  else if (response) yield put({ type: 'SET_USAGE_METRICS', payload: response['data']['body'] });
}

// Cancel Scheduled Plan Change
function* cancelScheduledPlanChange({ payload }) {
  const { successCallback, errorCallback } = payload || {};
  const { error, response } = yield call(deleteCall, '/payment/cancelScheduledPlanChange');
  if (error) {
    EventBus.publish('error', error['response']['data']['message']);
    if (errorCallback) errorCallback(error);
  } else if (response) {
    EventBus.publish('success', 'Scheduled plan change cancelled');
    yield put({ type: 'GET_CURRENT_PLAN' }); // Refresh current plan to clear pending change
    if (successCallback) successCallback(response['data']['body']);
  }
}

// Watcher saga for handling payment-related actions
function* actionWatcher() {
  yield takeEvery('GET_PLANS', getPlans);
  yield takeEvery('GET_PAYMENTS', getPayments);
  yield takeEvery('GET_CURRENT_PLAN', getCurrentPlan);
  yield takeEvery('GET_USAGE_METRICS', getUsageMetrics);
  yield takeEvery('GET_CREDIT_PACKAGES', getCreditPackages);
  yield takeEvery('CREATE_PORTAL_SESSION', createPortalSession);
  yield takeEvery('CREATE_CHECKOUT_SESSION', createCheckoutSession);
  yield takeEvery('CANCEL_SCHEDULED_PLAN_CHANGE', cancelScheduledPlanChange);
}

// Root saga for managing all payment-related actions
export default function* rootSaga() {
  yield all([actionWatcher()]);
}

// Helper function to make POST requests to the server
function postCall({ path, payload }) {
  return axios
    .post(path, payload)
    .then(response => ({ response }))
    .catch(error => {
      if (error.response.status === 401) EventBus.publish('tokenExpired');
      return { error };
    });
}

// Helper function to make GET requests to the server
function getCall(path) {
  return axios
    .get(path)
    .then(response => ({ response }))
    .catch(error => {
      if (error.response.status === 401) EventBus.publish('tokenExpired');
      return { error };
    });
}

// Helper function to make PUT requests to the server
function putCall({ path, payload }) {
  return axios
    .put(path, payload)
    .then(response => ({ response }))
    .catch(error => {
      if (error.response?.status === 401) EventBus.publish('tokenExpired');
      return { error };
    });
}

// Helper function to make DELETE requests to the server
function deleteCall(path) {
  return axios
    .delete(path)
    .then(response => ({ response }))
    .catch(error => {
      if (error.response?.status === 401) EventBus.publish('tokenExpired');
      return { error };
    });
}